import Link from 'next/link';
import { useRouter } from 'next/router';
import { MouseEventHandler } from 'react';
import styled, { css } from 'styled-components';

interface Props {
  forceMobile?: boolean;
}

const PRO_URL = 'https://playful-lycra-822.notion.site/1-bf06ca4bfff74ed297c912f5463ddf1f?pvs=74';

export default function Footer({ forceMobile = false }: Props) {
  const router = useRouter();

  const onClickLink: MouseEventHandler<HTMLAnchorElement> = (e) => {};

  return (
    <Container $forceMobile={forceMobile}>
      <Content>
        <OuterWrapper>
          <InnerWrapper>
            <LogoWrapper>
              <FakeText>생활연구소</FakeText>
              <Logo>{LogoSvg}</Logo>
            </LogoWrapper>
            <AnchorList>
              <AnchorWrapper>
                <AnchorLabel>회사</AnchorLabel>
                <Link href="/about" passHref>
                  <Anchor onClick={onClickLink}>청연이야기</Anchor>
                </Link>
                <Link href="https://cleaninglab-official.notion.site/fab33235930c479598c3b88c3cb169ba" passHref>
                  <Anchor onClick={onClickLink} target="_blank">
                    채용공고
                  </Anchor>
                </Link>
                <Link href="/news" passHref>
                  <Anchor onClick={onClickLink}>보도자료</Anchor>
                </Link>
                <Link href="https://blog.cleaninglab.co.kr" passHref>
                  <Anchor onClick={onClickLink} target="_blank">
                    청연 블로그 {LinkArrowSvg}
                  </Anchor>
                </Link>
              </AnchorWrapper>
              <AnchorWrapper>
                <AnchorLabel>서비스</AnchorLabel>
                <Link href="/home_clean" passHref>
                  <Anchor onClick={onClickLink}>가사 청소</Anchor>
                </Link>
                <Link href="/office_clean" passHref>
                  <Anchor onClick={onClickLink}>사무실 청소</Anchor>
                </Link>
                <Link href="/moving_clean" passHref>
                  <Anchor onClick={onClickLink}>이사·입주 청소</Anchor>
                </Link>
                <Link href="/store" passHref>
                  <Anchor onClick={onClickLink}>플러스샵</Anchor>
                </Link>
                <Link href="/gift" passHref>
                  <Anchor onClick={onClickLink}>선물하기</Anchor>
                </Link>
              </AnchorWrapper>
              <AnchorWrapper>
                <AnchorLabel>제휴안내</AnchorLabel>
                <Link href="/commerce/store-partnership-inquiry" passHref>
                  <Anchor onClick={onClickLink}>입점 문의</Anchor>
                </Link>
                <Link href="/b2b_introduction" passHref>
                  <Anchor onClick={onClickLink}>기업복지 문의</Anchor>
                </Link>
                <Link href="https://cleaninglab-official.notion.site/B2B-8a27c107a6024cddb684aeb4cde110a1" passHref>
                  <Anchor onClick={onClickLink} target="_blank">
                    제휴 문의 {LinkArrowSvg}
                  </Anchor>
                </Link>
              </AnchorWrapper>
              <AnchorWrapper>
                <AnchorLabel>모집</AnchorLabel>
                <Link href="/manager_apply" passHref>
                  <Anchor onClick={onClickLink} target="_blank">
                    청연매니저 {LinkArrowSvg}
                  </Anchor>
                </Link>
                <Link passHref href={PRO_URL}>
                  <Anchor onClick={onClickLink} target="_blank" rel="noopener noreferrer">
                    청연프로 {LinkArrowSvg}
                  </Anchor>
                </Link>
              </AnchorWrapper>

              <AnchorWrapper>
                <AnchorLabel>지원안내</AnchorLabel>
                <Link href={`${process.env.NEXT_PUBLIC_VIEW_URL}/partner/intro`} passHref>
                  <Anchor onClick={onClickLink} target="_blank" rel="noopener noreferrer">
                    청연 파트너 {LinkArrowSvg}
                  </Anchor>
                </Link>
                <Link passHref href="/user-partner">
                  <Anchor onClick={onClickLink} target="_blank">
                    청연 추천프로그램 {LinkArrowSvg}
                  </Anchor>
                </Link>
              </AnchorWrapper>
            </AnchorList>
          </InnerWrapper>
          <SciList>
            <Link href="https://blog.naver.com/cleaninglab2017" passHref>
              <Sci target="_blank">
                <FakeText>생활연구소 네이버 블로그</FakeText>
                <SciIcon>{NaverBlogSvg}</SciIcon>
              </Sci>
            </Link>
            <Link href="https://www.instagram.com/cleaninglab_official" passHref>
              <Sci target="_blank">
                <FakeText>생활연구소 인스타그램</FakeText>
                <SciIcon>{InstagramSvg}</SciIcon>
              </Sci>
            </Link>
            <Link href="https://www.youtube.com/channel/UCF_85IHPTJNxaTnmr0DqILw" passHref>
              <Sci target="_blank">
                <FakeText>생활연구소 유튜브</FakeText>
                <SciIcon>{YoutubeSvg}</SciIcon>
              </Sci>
            </Link>
          </SciList>
        </OuterWrapper>
        <InfoWrapper>
          <Information>
            <InfoText>(주)생활연구소 | 사업자 등록번호 : 837-87-00683 | 대표 : 연현주</InfoText>
            <InfoText>
              주소 : 경기도 성남시 분당구 판교로 242, C동 10층 1002호(삼평동, 판교디지털센터) | 이메일 :
              cleaninglab@cleaninglab.co.kr | 대표번호 : 1877-7753
            </InfoText>
            <InfoText>통신판매업 신고번호 : 2017-성남분당-0155 | 등록번호 : 제 2017-3780288-14-5-00012호</InfoText>
          </Information>
          <Copyright>Copyright(c) Lifelab Corp. All right reserved.</Copyright>
        </InfoWrapper>
      </Content>
    </Container>
  );
}

const Content = styled.div`
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};
`;

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 80px;
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 92px;
`;

const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FakeText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const AnchorList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
`;

const AnchorWrapper = styled.li`
  display: flex;
  flex-direction: column;
  margin-right: 32px;
  width: 82px;
  white-space: nowrap;
`;

const AnchorLabel = styled.span`
  font-weight: 500;
  font-size: 15px;
  line-height: 140%;
  color: #ffffff;
  opacity: 0.8;
  margin-bottom: 12px;
`;

const Anchor = styled.a`
  font-weight: 300;
  font-size: 15px;
  line-height: 140%;
  color: #ffffff;
  opacity: 0.4;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;

const SciList = styled.div`
  display: flex;
`;

const Sci = styled.a`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.2);
  margin-right: 14px;

  &:last-child {
    margin-right: 0;
  }
`;

const SciIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const InfoWrapper = styled.div`
  position: relative;
`;

const Information = styled.div`
  margin-bottom: 20px;
`;

const InfoText = styled.p`
  font-weight: 300;
  font-size: 12px;
  line-height: 140%;
  color: rgba(255, 255, 255, 0.7);
`;

const Copyright = styled.p`
  font-weight: 300;
  font-size: 12px;
  line-height: 140%;
  color: rgba(255, 255, 255, 0.7);
`;

const RightArea = styled.div<{ $forceMobile: boolean }>`
  position: absolute;
  right: 0;
  top: 0;

  ${({ theme, $forceMobile }) => css`
    @media (${$forceMobile ? `min-width: 0` : `max-width: ${theme.brandSitesV2!.breakpoints.mobile}`}) {
      display: none;
    }
  `}
`;

const RightAreaFirstButton = styled.div`
  position: absolute;
  left: 0;
  top: 0%;
  width: 100%;
  height: 25%;
  z-index: 99999;
`;

const RightAreaSecondButton = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 40%;
  z-index: 99999;
`;

const Container = styled.footer<{ $forceMobile: boolean }>`
  width: 100%;
  padding: 0 24px;
  padding-top: 50px;
  padding-bottom: 40px;
  background: #42484c;

  ${({ theme, $forceMobile }) => css`
    @media (${$forceMobile ? `min-width: 0` : `max-width: ${theme.brandSitesV2!.breakpoints.tablet}`}) {
      padding-top: 34px;

      ${Content} {
        max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints!.tablet};
      }

      ${OuterWrapper} {
        flex-direction: column;
        justify-content: flex-start;
        margin-bottom: 20px;
      }

      ${InnerWrapper} {
        margin-bottom: 80px;
      }

      ${LogoWrapper} {
        margin-right: 50px;
      }

      ${AnchorList} {
        flex-wrap: wrap;
        justify-content: flex-start;
      }

      ${AnchorWrapper} {
        margin-right: 60px;
      }
    }
  `}

  ${({ theme, $forceMobile }) => css`
    @media (${$forceMobile ? `min-width: 0` : `max-width: ${theme.brandSitesV2!.breakpoints.mobile}`}) {
      padding-top: 40px;

      ${OuterWrapper} {
        margin-bottom: 27px;
      }

      ${InnerWrapper} {
        flex-direction: column;
      }

      ${LogoWrapper} {
        margin-bottom: 40px;
      }

      ${AnchorList} {
        flex-wrap: wrap;
        justify-content: space-between;
        @media (min-width: 486px) and (max-width: 631px) {
          justify-content: flex-start;
        }
      }

      ${AnchorWrapper} {
        width: 50%;
        max-width: 130px;
        margin-bottom: 32px;
        margin-right: 16px;
      }

      ${AnchorLabel} {
        margin-bottom: 16px;
      }

      ${Anchor} {
        font-weight: 400;
      }

      ${InfoText} {
        font-weight: 400;
      }

      ${Copyright} {
        font-weight: 400;
      }
    }
  `}
`;

const LogoSvg = (
  <svg width="82" height="19" viewBox="0 0 82 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <g clipPath="url(#clip0_1972_26382)">
        <path
          d="M44.1749 6.27249L44.0469 8.1785H46.64V12.0049H48.9053V0.0292969H46.64V2.54931H44.0469L44.1749 4.45532H46.64V6.27249H44.1749Z"
          fill="white"
        />
        <path d="M40.7797 11.1152H38.4883V16.9378H38.9416H40.7797H49.4266V15.0318H40.7797V11.1152Z" fill="white" />
        <path
          d="M43.4322 5.13213C43.4322 4.19474 43.1543 3.27839 42.6335 2.49897C42.1127 1.71956 41.3725 1.11208 40.5064 0.753354C39.6404 0.394629 38.6874 0.300774 37.768 0.48365C36.8487 0.666527 36.0041 1.11792 35.3413 1.78076C34.6785 2.4436 34.2271 3.28811 34.0442 4.20749C33.8613 5.12687 33.9552 6.07983 34.3139 6.94587C34.6726 7.81191 35.2801 8.55213 36.0595 9.07292C36.8389 9.59371 37.7553 9.87168 38.6927 9.87168C39.9493 9.87029 41.154 9.3705 42.0425 8.48196C42.9311 7.59342 43.4308 6.38871 43.4322 5.13213ZM35.9989 5.13213C35.9989 4.59904 36.157 4.07793 36.4532 3.6347C36.7494 3.19147 37.1704 2.84603 37.6629 2.64209C38.1555 2.43814 38.6974 2.38485 39.2202 2.48894C39.7431 2.59304 40.2233 2.84985 40.6001 3.22689C40.977 3.60393 41.2336 4.08427 41.3374 4.60715C41.4413 5.13002 41.3877 5.67195 41.1835 6.16439C40.9793 6.65683 40.6337 7.07765 40.1903 7.37363C39.7469 7.66961 39.2258 7.82745 38.6927 7.82719C37.9789 7.82547 37.295 7.5408 36.7907 7.0356C36.2865 6.5304 36.0032 5.84589 36.0028 5.13213H35.9989Z"
          fill="white"
        />
        <path
          d="M65.5111 8.17809H62.4006C62.8645 6.03777 63.0728 3.84997 63.0212 1.66056V0.746094H51.9901V2.65341H60.8539C60.8356 3.84221 60.7232 6.02518 60.1746 8.17809H50.0566V10.0841H56.6735V16.9374H58.9649V10.0841H65.5111V8.17809Z"
          fill="white"
        />
        <path d="M73.7808 8.53906H71.4894V12.1316H64.7236V14.0376H80.5478V12.1316H73.7808V8.53906Z" fill="white" />
        <path
          d="M72.6125 4.35367C73.3127 5.82204 74.8529 7.68755 78.2482 8.89465L79.326 7.23554C74.1122 5.56468 73.9633 2.31702 73.9385 2.0479V0.349609H71.3374V2.0479C71.3074 2.36144 71.0082 5.53594 65.9316 7.20419L67.0068 8.86068C70.3315 7.64836 71.8848 5.80636 72.6125 4.35367Z"
          fill="white"
        />
        <path
          d="M8.15184 9.27027L9.46997 7.47661C7.58748 6.55039 6.3255 4.61564 6.3255 2.04729V0.734375H4.00929V2.10085C4.00929 4.6496 2.83356 6.81819 0.587891 8.02137L1.76363 9.79804C3.56644 8.73857 4.73696 7.41521 5.22685 6.01868C5.70368 7.30678 6.92776 8.57135 8.15184 9.27027Z"
          fill="white"
        />
        <path
          d="M13.726 3.57687H12.1818V0.2456H9.94141V9.19692H12.1818V5.50378H13.726V9.65415H15.9664V0H13.726V3.57687Z"
          fill="white"
        />
        <path
          d="M11.2112 9.68359C8.59847 9.68359 6.47168 11.7738 6.47168 14.3421C6.47168 16.9105 8.59716 18.9994 11.2112 18.9994C13.8253 18.9994 15.9495 16.9092 15.9495 14.3421C15.9495 11.7751 13.824 9.68359 11.2112 9.68359ZM11.2112 16.9902C10.6895 16.9812 10.1821 16.8182 9.75273 16.5218C9.32332 16.2255 8.99105 15.8088 8.79762 15.3242C8.60419 14.8396 8.55822 14.3087 8.6655 13.7981C8.77278 13.2875 9.02852 12.8199 9.40061 12.4541C9.7727 12.0884 10.2446 11.8407 10.7569 11.7421C11.2693 11.6436 11.7994 11.6987 12.2806 11.9004C12.7618 12.1021 13.1727 12.4414 13.4617 12.8758C13.7507 13.3103 13.9049 13.8204 13.905 14.3421C13.8984 15.0506 13.6111 15.7275 13.1062 16.2244C12.6012 16.7213 11.9197 16.9977 11.2112 16.9928V16.9902Z"
          fill="white"
        />
        <path
          d="M22.9575 15.8061H31.3118V11.4297H20.6504V13.3396H29.0413V14.0686H20.6687V18.445H31.6096V16.535H22.9575V15.8061Z"
          fill="white"
        />
        <path d="M25.0801 0.00976562H20.4268V1.85568H25.0801V0.00976562Z" fill="white" />
        <path
          d="M31.311 0H29.0222V8.2302C27.3837 8.76058 25.673 9.03425 23.9508 9.04146H23.892V8.58685C25.4597 8.1675 26.5897 6.9003 26.5897 5.12754C26.5891 4.86341 26.5571 4.60029 26.4943 4.34372H27.8883V2.49258H17.3418V4.3398H18.95C18.8879 4.59649 18.8559 4.85954 18.8546 5.12363C18.8546 6.89639 19.9886 8.16358 21.5523 8.58292V9.03754H17.3301L17.5678 10.826H23.9508C25.6719 10.8259 27.3827 10.5592 29.0222 10.0356V10.6705H31.311V6.62074H33.8127V4.71342H31.311V0ZM22.6209 6.89116C21.7848 6.89116 21.2087 6.23797 21.2087 5.44239C21.225 5.05171 21.3916 4.68242 21.6737 4.41173C21.9559 4.14104 22.3318 3.98989 22.7228 3.98989C23.1138 3.98989 23.4897 4.14104 23.7719 4.41173C24.0541 4.68242 24.2207 5.05171 24.2369 5.44239C24.2369 6.24189 23.4609 6.89116 22.6209 6.89116Z"
          fill="white"
        />
        <path
          d="M80.5502 0.345952C80.2777 0.340762 80.0099 0.41684 79.7808 0.56449C79.5518 0.712141 79.3719 0.924669 79.2642 1.17497C79.1564 1.42526 79.1256 1.70199 79.1758 1.96985C79.2259 2.2377 79.3547 2.48454 79.5457 2.6789C79.7368 2.87325 79.9813 3.00631 80.2483 3.06109C80.5152 3.11588 80.7924 3.08991 81.0446 2.9865C81.2967 2.88309 81.5123 2.70692 81.6639 2.48047C81.8155 2.25402 81.8962 1.98755 81.8957 1.71504C81.8999 1.53608 81.8682 1.3581 81.8023 1.19165C81.7365 1.02519 81.6379 0.873635 81.5125 0.745967C81.387 0.6183 81.2372 0.517115 81.0719 0.448404C80.9066 0.379692 80.7292 0.344854 80.5502 0.345952ZM80.5502 2.88947C79.897 2.88947 79.4411 2.39958 79.4411 1.71373C79.4411 1.02788 79.897 0.545824 80.5502 0.545824C81.2034 0.545824 81.6619 1.02527 81.6619 1.71373C81.6619 2.40219 81.1903 2.88425 80.5502 2.88425V2.88947Z"
          fill="white"
        />
        <path
          d="M80.289 1.7336V1.66045C80.289 1.36782 80.4197 1.24633 80.6418 1.24633C80.7599 1.24649 80.8767 1.27048 80.9853 1.31687V1.02686C80.8665 0.971387 80.7362 0.944964 80.6052 0.949776C80.2211 0.949776 79.8984 1.15488 79.8984 1.69311V1.73752C79.8984 2.23917 80.1754 2.48085 80.5908 2.48085C80.7316 2.48249 80.8706 2.44976 80.9958 2.38549V2.1007C80.8941 2.15766 80.7792 2.18694 80.6627 2.18561C80.3909 2.18431 80.289 2.03407 80.289 1.7336Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1972_26382">
        <rect width="81.3026" height="19" fill="white" transform="translate(0.587891)" />
      </clipPath>
    </defs>
  </svg>
);

const NaverBlogSvg = (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1451 8.73983C17.1451 10.517 15.5153 10.4992 15.5153 10.4992H15.0807V9.50163H15.3504C16.1398 9.50163 16.0606 8.6773 16.0606 8.6773V8.41486C15.7129 8.86919 15.0807 8.84481 15.0807 8.84481C13.5299 8.84481 13.5469 7.17234 13.5469 7.17234C13.5469 5.37797 15.1239 5.4471 15.1239 5.4471C15.7401 5.4471 16.0606 5.87676 16.0606 5.87676V5.55695H17.1451V8.73983ZM12.9837 7.18432C12.9837 8.89723 11.0985 8.90067 11.0985 8.90067C9.19651 8.90067 9.25527 7.18432 9.25527 7.18432C9.25527 5.44674 11.0985 5.44674 11.0985 5.44674C13.0459 5.44674 12.9837 7.18432 12.9837 7.18432ZM8.4701 5.74834V8.7835H7.39449V6.0059C7.39449 5.04705 6.8872 5.07029 6.8872 5.07029V3.98179C8.51666 3.98179 8.4701 5.74834 8.4701 5.74834ZM4.95661 8.89983C4.28496 8.89983 4.01925 8.41366 4.01925 8.41366V8.78109H2.8931V4.08751H4.00676V5.87557C4.45869 5.42984 4.95661 5.42984 4.95661 5.42984C6.46939 5.42984 6.5273 7.14447 6.5273 7.14447C6.5273 8.8396 4.95661 8.89983 4.95661 8.89983ZM16.2494 0.359375H3.78689C2.19661 0.359375 0.910645 1.66758 0.910645 3.27752V10.1991C0.910645 11.8096 2.19661 13.1156 3.78689 13.1156H8.08054L9.54535 15.5243C9.54535 15.5243 9.56068 15.5544 9.59219 15.594C9.67849 15.7429 9.83632 15.8438 10.0189 15.8438C10.2 15.8438 10.3561 15.7429 10.4427 15.5974C10.4796 15.5544 10.4924 15.5243 10.4924 15.5243L11.956 13.1156H16.2494C17.838 13.1156 19.1276 11.8096 19.1276 10.1991V3.27752C19.1276 1.66758 17.838 0.359375 16.2494 0.359375ZM10.3827 7.18448C10.3827 6.7835 10.702 6.46082 11.0989 6.46082C11.4946 6.46082 11.8148 6.7835 11.8148 7.18448C11.8148 7.58402 11.4946 7.90727 11.0989 7.90727C10.702 7.90727 10.3827 7.58402 10.3827 7.18448ZM14.6772 7.18448C14.6772 6.7835 14.9985 6.46082 15.394 6.46082C15.79 6.46082 16.1096 6.7835 16.1096 7.18448C16.1096 7.58402 15.79 7.90727 15.394 7.90727C14.9985 7.90727 14.6772 7.58402 14.6772 7.18448ZM3.99481 7.18448C3.99481 6.7835 4.31446 6.46082 4.71047 6.46082C5.10619 6.46082 5.42697 6.7835 5.42697 7.18448C5.42697 7.58402 5.10619 7.90727 4.71047 7.90727C4.31446 7.90727 3.99481 7.58402 3.99481 7.18448Z"
      fill="white"
    />
  </svg>
);

const InstagramSvg = (
  <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9337 14.0243C16.9337 15.951 15.3703 17.5159 13.4431 17.5159H5.56133C3.63519 17.5159 2.07043 15.951 2.07043 14.0243V6.142C2.07043 4.21403 3.63519 2.65138 5.56133 2.65138H13.4431C15.3703 2.65138 16.9337 4.21403 16.9337 6.142V14.0243ZM13.3537 0.929688H5.65206C2.74835 0.929688 0.394043 3.2836 0.394043 6.18794V13.8894C0.394043 16.7957 2.74835 19.1467 5.65206 19.1467H13.3537C16.2584 19.1467 18.611 16.7957 18.611 13.8894V6.18794C18.611 3.2836 16.2584 0.929688 13.3537 0.929688ZM9.50219 13.1447C7.811 13.1447 6.43849 11.7737 6.43849 10.0813C6.43849 8.38829 7.811 7.01531 9.50219 7.01531C11.195 7.01531 12.5665 8.38829 12.5665 10.0813C12.5665 11.7737 11.195 13.1447 9.50219 13.1447ZM9.50202 5.35403C6.89061 5.35403 4.77613 7.47069 4.77613 10.0817C4.77613 12.6908 6.89061 14.8081 9.50202 14.8081C12.1121 14.8081 14.2305 12.6908 14.2305 10.0817C14.2305 7.47069 12.1121 5.35403 9.50202 5.35403ZM13.2861 5.17625C13.2861 4.56814 13.7801 4.07507 14.3878 4.07507C14.9965 4.07507 15.4889 4.56814 15.4889 5.17625C15.4889 5.78567 14.9965 6.27809 14.3878 6.27809C13.7801 6.27809 13.2861 5.78567 13.2861 5.17625Z"
      fill="white"
    />
  </svg>
);

const YoutubeSvg = (
  <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.31194 8.7355V4.12592L12.6789 6.37613L8.31194 8.7355ZM18.8519 2.37686C18.5032 1.00195 17.8522 0.47415 16.6533 0.284043C15.965 0.183061 12.6508 0.0546875 10.019 0.0546875C7.38724 0.0546875 4.0734 0.183061 3.38512 0.284043C2.18706 0.47415 1.53439 1.00522 1.1886 2.37686C1.0714 2.83475 0.911133 5.36215 0.911133 6.32413V6.53714C0.911133 7.50034 1.0714 10.0253 1.1886 10.4865C1.53439 11.8577 2.18706 12.3863 3.38512 12.5764C4.0734 12.6778 7.39221 12.8049 10.0256 12.8049L10.0136 12.8066C12.6479 12.8066 15.9634 12.6778 16.6533 12.5764C17.8522 12.3863 18.5032 11.8577 18.8519 10.4865C18.9679 10.0253 19.1281 7.50034 19.1281 6.53714V6.32413C19.1281 5.36215 18.9679 2.83475 18.8519 2.37686Z"
      fill="white"
    />
  </svg>
);

const LinkArrowSvg = (
  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.899969 0.226807C0.568598 0.226807 0.299969 0.495436 0.299969 0.826807C0.299969 1.15818 0.568598 1.42681 0.899969 1.42681H4.53653L0.328147 5.75505C0.097145 5.99264 0.102479 6.3725 0.34006 6.6035C0.577641 6.8345 0.957503 6.82917 1.1885 6.59159L5.29076 2.37249V5.82346C5.29076 6.15483 5.55938 6.42346 5.89076 6.42346C6.22213 6.42346 6.49076 6.15483 6.49076 5.82346V0.826807V0.226807H5.89076H0.899969Z"
        fill="white"
      />
    </g>
  </svg>
);
